import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import axiosPrivate from "../../services/api";
import toast from "react-hot-toast";

export const asyncGetPassengers = createAsyncThunk(
  "getPassengers",
  async (obj, { dispatch, getState, rejectWithValue, fulfillWithValue }) => {
    const country = getState().auth.country;
    try {
      const response = await axiosPrivate.get(
        `/passengers${country ? `?country=${country}` : ""}`
      );

      return fulfillWithValue(response.data);
    } catch (error) {
      console.log("err==>", error.response.data.message);
      toast.error(error.response.data.message);

      throw rejectWithValue(error.response.data.message);
    }
  }
);

export const asyncGetPassengerDetail = createAsyncThunk(
  "getPassengerDetail",
  async (obj, { dispatch, getState, rejectWithValue, fulfillWithValue }) => {
    const { id } = obj;
    try {
      const response = await axiosPrivate.get(`/passengers/${id}`);
      return fulfillWithValue(response.data);
    } catch (error) {
      console.log("err==>", error.response.data.message);
      toast.error(error.response.data.message);
      throw rejectWithValue(error.response.data.message);
    }
  }
);

export const asyncCreatePassenger = createAsyncThunk(
  "createPassengers",
  async (
    payload,
    { dispatch, getState, rejectWithValue, fulfillWithValue }
  ) => {
    const { obj, callback } = payload;

    try {
      const response = await axiosPrivate.post("/passengers", obj);
      toast.success("Passenger created Successfully");
      callback && callback();
      return fulfillWithValue(response.data);
    } catch (error) {
      console.log("err==>", error.response.data.message);
      toast.error(error.response.data.message);

      throw rejectWithValue(error.response.data.message);
    }
  }
);
export const asyncUpdatePassenger = createAsyncThunk(
  "updatePassenger",
  async (
    { id, obj, callback },
    { dispatch, getState, rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const response = await axiosPrivate.patch(`/passengers/${id}`, obj);
      toast.success("Passenger updated Successfully");
      callback && callback();
      return fulfillWithValue(response.data);
    } catch (error) {
      console.log("err==>", error.response.data.message);
      toast.error(error.response.data.message);

      throw rejectWithValue(error.response.data.message);
    }
  }
);

const passengerSlice = createSlice({
  name: "passengers",
  initialState: {
    isLoading: false,
    // userInfo: localStorage.getItem("auth") ? JSON.parse(localStorage.getItem("auth")) : null,
    list: [],
    isError: false,
    add: {},
    update: {},
    passengerDetails: { isLoading: false, data: {}, isError: false },
  },
  extraReducers: (builder) => {
    // Cases for Get Passengers

    builder.addCase(asyncGetPassengers.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(asyncGetPassengers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.list = action.payload;
      state.isError = false;
      state.message = null;
    });
    builder.addCase(asyncGetPassengers.rejected, (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
      state.isError = true;
    });

    builder.addCase(asyncGetPassengerDetail.pending, (state, action) => {
      state.passengerDetails.isLoading = true;
    });
    builder.addCase(asyncGetPassengerDetail.fulfilled, (state, action) => {
      state.passengerDetails.isLoading = false;
      state.passengerDetails.data = action.payload;
      state.passengerDetails.isError = false;
      state.passengerDetails.message = null;
    });
    builder.addCase(asyncGetPassengerDetail.rejected, (state, action) => {
      state.passengerDetails.isLoading = false;
      state.passengerDetails.message = action.payload;
      state.passengerDetails.isError = true;
    });
    // Cases for Add Passenger
    builder.addCase(asyncCreatePassenger.pending, (state, action) => {
      state.add = { isLoading: true };
    });
    builder.addCase(asyncCreatePassenger.fulfilled, (state, action) => {
      state.add = {
        isLoading: false,
        message: "Passenger Created Successfully!",
      };
      state.list.push(action.payload);
    });

    builder.addCase(asyncCreatePassenger.rejected, (state, action) => {
      state.add = { isLoading: false, isError: true, message: action.payload };
    });

    // Cases for Update Passenger
    builder.addCase(asyncUpdatePassenger.pending, (state, action) => {
      state.update = { isLoading: true };
    });
    builder.addCase(asyncUpdatePassenger.fulfilled, (state, action) => {
      state.add = {
        isLoading: false,
        message: "Passenger Updated Successfully!",
      };
      state.list = state.list.map((x) =>
        x._id === action.payload._id ? action.payload : x
      );
    });

    builder.addCase(asyncUpdatePassenger.rejected, (state, action) => {
      state.update = {
        isLoading: false,
        isError: true,
        message: action.payload,
      };
    });
  },
  reducers: {},
});

// export const {} = passengerSlice.actions;
export default passengerSlice.reducer;
